import React from 'react'
import Landing from '../components/Landing'

export default () => (
  <Landing />
)
